<template>
  <div class="modal-wrap">
    <el-dialog title="验收" :visible.sync="dialogVisible" width="503px" :close-on-click-modal="false">
      <div class="form-wrap">
        <table border="1" cellpadding="0px" cellspacing="0px" class="ma-table">
          <tr>
            <td class="header-cell">素材组名称</td>
            <td class="header-cell">素材组地址</td>
          </tr>
          <tr v-for="(item, index) of tableData" :key="index">
            <td style="width: 180px">
              <el-input v-if="!readonly" class="cell-input" v-model="item.materialName" placeholder="请输入名称"></el-input>
              <span class="show-cell" v-else>{{ item.materialName }}</span>
            </td>
            <td>
              <div v-if="!readonly" class="input-wrap">
                <el-input class="cell-input" v-model="item.materialAddr" placeholder="请输入地址"> </el-input>
                <svg-icon v-if="!item.id" iconClass="delete" className="del-icon" @click="delLine(item)"></svg-icon>
              </div>
              <div class="show-cell link-wrap" v-else>
                <span class="link-text">{{ item.materialAddr }}</span
                ><i @click="copyData(item)" class="el-icon-document-copy copy-icon"></i>
              </div>
            </td>
          </tr>
          <tr v-if="!readonly">
            <td class="add-btn-line" @click="addLine" colspan="2"><i class="el-icon-plus"></i> 添加</td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="readonly" type="primary" @click="readonly = false">编辑</el-button>
        <el-button v-if="!readonly" @click="dialogVisible = false">取消</el-button>
        <el-button v-if="!readonly" :loading="loading" type="primary" @click="saveData">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { modifyMaterial } from "@/api/materialManage.js";
import SvgIcon from "@/components/SvgIcon.vue";
import { copyText } from "@/utils/tool.js";
export default {
  name: "CheckModal",
  components: {
    SvgIcon,
  },
  data() {
    return {
      dialogVisible: false,
      readonly: true,
      totalData: {},
      tableData: [],
      loading: false,
    };
  },
  methods: {
    showModal(data) {
      this.totalData = data; //保存所有数据
      if (data.materialGroupInfos.length > 0) {
        this.readonly = true;
        this.tableData = data.materialGroupInfos.map((item) => {
          item.key = Math.random();
          return item;
        });
      } else {
        this.readonly = false;
        this.tableData = [
          {
            key: Math.random(),
            materialName: "",
            materialAddr: "",
          },
        ];
      }
      this.dialogVisible = true;
    },
    addLine() {
      this.tableData.push({
        key: Math.random(),
        materialName: "",
        materialAddr: "",
      });
    },
    delLine(item) {
      let delIndex = this.tableData.findIndex((line) => line.key === item.key);
      if (delIndex !== -1) {
        this.tableData.splice(delIndex, 1);
      }
    },
    saveData() {
      if (this.tableData.length === 0) {
        this.$message({
          message: "请至少填写一条素材信息",
          type: "warning",
        });
        return;
      }
      let errorData = this.tableData.find((item) => item.materialName === "" || item.materialAddr === "");
      if (errorData) {
        this.$message({
          message: "素材信息填写不完整",
          type: "warning",
        });
        return;
      }

      let nameArr = this.tableData.map((item) => item.materialName);
      let setArr = new Set(nameArr);
      if (nameArr.length !== setArr.size) {
        this.$message({
          message: "素材组名称不能重复",
          type: "warning",
        });
        return;
      }

      this.totalData.materialGroupInfos = this.tableData;
      this.loading = true;
      const { id, materialGroupInfos } = this.totalData;
      const params = {
        id,
        materialGroupInfos,
      };
      modifyMaterial(params).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message({
            message: "素材修改成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.$emit("refresh", false);
        }
      });
    },
    copyData(data) {
      let text = data.materialAddr;
      if (text && copyText(text)) {
        this.$message({
          message: "素材地址复制成功",
          type: "success",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .form-wrap {
    border-radius: 5px;
    .ma-table {
      border-collapse: collapse;
      width: 100%;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      .header-cell {
        background: rgba(0, 0, 0, 0.02);
        height: 54px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 14px;
        padding-left: 20px;
      }
      td {
        border: 1px solid rgba(217, 217, 217, 0.55);
        height: 54px;
        .cell-input {
          height: 54px;
          width: 100%;
          /deep/ .el-input__inner {
            height: 100%;
            border: none;
            outline: none;
          }
        }
        .show-cell {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          padding: 0 14px;
          &.link-wrap {
            width: 230px;
            height: 54px;
            display: flex;
            align-items: center;
            .link-text {
              color: rgba(24, 144, 255, 1);
              font-size: 14px;
              text-decoration-line: underline;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .copy-icon {
              flex-shrink: 0;
              display: none;
              color: rgba(24, 144, 255, 1);
              font-size: 16px;
              cursor: pointer;
              margin-left: 4px;
            }
            &:hover .copy-icon {
              display: inline-block;
            }
          }
        }
      }
      .add-btn-line {
        border: 1px solid rgba(217, 217, 217, 0.55);
        height: 50px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        color: #409eff;
      }
      .input-wrap {
        position: relative;
        .del-icon {
          display: none;
        }
        &:hover .del-icon {
          display: inline-block;
          position: absolute;
          right: 2px;
          top: 18px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
